// skrývání toolbaru při scrollu
function footerMobileCta() {
  //let scrollValue = parseInt($(window).innerHeight() / 2);
  let scrollValue = 270;
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= scrollValue) {
      $('.js-footer-cta').addClass('is-active');
    } else {
      $('.js-footer-cta').removeClass('is-active');
    }
  });
}
